import { useTranslation } from 'react-i18next';

import { translations } from '../../../../../../../locales/translations';
import { BookingActionType } from '../../../../../../../types/BookingType';
import { ActivityData } from '../../ActivityData';
import { BuilderDecisionParams } from '../../BuilderDecisionParams';
import { EventMessageBuilder } from '../../EventMessageBuilder';

export const useBookingCreatedMessageBuilder = (): EventMessageBuilder => {
  const { t } = useTranslation();

  const supports = (params: BuilderDecisionParams): boolean => {
    return params.eventResult.type === BookingActionType.BOOKING_CREATED;
  };

  const build = (_: ActivityData): string => {
    return t(translations.pages.booking.features.activity.bookingCreated);
  };

  return {
    supports,
    build
  };
};
